// src/data/education.js
const education = [
  {
    degree: "Bachelor of Science in Computer Science and Engineering",
    institution: "BRAC University",
    duration: "2022 - Present",
    gpa: "CGPA : X.XX",
    semester: "Semester : 9th",
    credit: "Completed Credit : 99/136",
  },
  {
    degree: "Higher Secondary Certificate - HSC",
    institution: "Sirajganj Govt. College",
    duration: "2019 - 2021",
    board: "Board : Rajshahi",
    gpa: "GPA   : 5.00",
  },
  {
    degree: " Secondary School Certificate - SSC",
    institution: "Sirajanj B.L Govt. High School",
    duration: "2019",
    board: "Board : Rajshahi",
    gpa: "GPA   : 5.00",
  },
];

export default education;
